import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-white mt-5 py-3">
      <div className="container text-center">
        <span className="d-block">
          © {new Date().getFullYear()} TOORANT COMMUNICATIONS - 9638480441
        </span>
        <small className="d-block">All rights reserved.</small>
      </div>
    </footer>
  );
}

export default Footer;
